module.exports = __webpack_public_path__ + "static/img/VDadvantage3.5202783.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/VDadvantage3.png
// module id = jIT9
// module chunks = 0